<template lang="pug">
b-modal#editCustom(
  ref="editCustom"
  :title="$t('ui.edit_custom')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      template(v-if="customerInfo != null")
        .form-group
          span.badge.badge-info {{ customerInfo.id }}
        b-form-group(:label="$t('ui.phone')" disabled).mb-1
          DebounceInput(
            ref="phone"
            size="sm"
            required
            type="text"
            v-model="phone"
          )
        b-form-group(:label="$t('ui.status')").mb-0
          DebounceInput(
            size="sm"
            ref="status"
            required
            type="text"
            :dirty="$v.status.$dirty"
            :error="$v.status.$error"
            v-model.trim.lazy="$v.status.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.status" :name="$t('ui.status')")
        b-form-group(:label="$t('ui.remark')").mb-0
          DebounceInput(
            size="sm"
            ref="remark"
            required
            type="text"
            :dirty="$v.remark.$dirty"
            :error="$v.remark.$error"
            v-model.trim.lazy="$v.remark.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.remark" :name="$t('ui.remark')")


    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    customerInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      phone: "",
      status: "",
      remark: ""
    };
  },
  validations() {
    return {
      status: {
        required,
        minLength: minLength(3)
      },
      remark: {
        minLength: minLength(3)
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submit();
    },
    submit: function() {
      let url = config.cpiMemberCustomEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        phone: this.customerInfo.phone,
        new_status: this.status,
        remark: this.remark
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editCustom.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_custom", this.feedback.status);
                this.$refs.editCustom.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.phone = ""
      this.status = ""
      this.remark = ""
      this.$v.$reset();
    },
    shown: function() {
      this.phone = this.customerInfo.phone
      this.status = this.customerInfo.status
      this.remark = this.customerInfo.remark
    }
  }
};
</script>
